<template lang="pug">
  .expert-form
    .options-block
      .meet
        //lei-popover(:text="tooltips.meetAny")
          p.inline Meet all
        //el-select.meet-select.xs.light.lei-select(v-model="meet")
          el-option(v-for="o, i in options", :key="i", :label="o", :value="o")
        //p.inline of the following criteria
      .config
        //lei-popover(:text="tooltips.saveSearch")
          lei-btn.config-btn(@click="test" custom) Save search configuration
        lei-popover(:text="tooltips.resetSearch")
          lei-btn.config-btn(@click="resetCriterias" type="turquoise-keyline", size="sm", fill) Clear filters
    .criteria-block
      criteria(@enter="routerSearch")
    <!--.historical-date-->
      <!--date-picker.datepicker(-->
      <!--mode="range",-->
      <!--label="Include historical data",-->
      <!--:date-one="historicalDate.dateOne",-->
      <!--:date-two="historicalDate.dateTwo",-->
      <!--@remove="clearDates",-->
      <!--@date-one-selected="val => { setDate({index: 'dateOne', date: val}) }",-->
      <!--@date-two-selected="val => { setDate({index: 'dateTwo', date: val}) }")-->
    .actions-block
      lei-popover.add-btn-tip-box(v-if="criteriaCount < maxCriteria", :text="tooltips.addSearchCriteria")
        lei-btn.add-btn(@click="addCriteria", type="turquoise-keyline") Add filter
      p.notification-text(v-else) Maximum number of search filters ({{maxCriteria}}) reached
      lei-popover(:text="tooltips.serchNow")
        lei-btn.search-btn(@click="routerSearch", type="turquoise", fill) Search now
</template>
<script>
import { mapActions, mapGetters, mapMutations, mapState, } from 'vuex'
import {
  ADD_CRITERIA,
  REMOVE_HISTORICAL_DATE,
  RESET_CRITERIA,
  SET_HISTORICAL_DATE,
} from '../../store/modules/search/mutations-types'
import routerSearch from '../../mixins/router-search-mixin'
import LeiBtn from '../lei-components/LeiBtn'
import Criteria from './Criteria'
import DatePicker from '../lei-components/inputs/DatePicker'
import LeiPopover from '../lei-components/LeiPopover'
import expert from '../../constants/tooltips/expert'
import { EventBus, } from '../../event-bus'

export default {
  components: {
    LeiPopover,
    DatePicker,
    Criteria,
    LeiBtn,
  },
  mixins: [ routerSearch, ],
  props: {
    title: {
      type: String,
      default: 'LEI Search',
    },
    info: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      meet: 'All',
      maxCriteria: 20,
      options: [ 'All', 'One', 'None', ],
      tooltips: expert,
    }
  },
  computed: {
    ...mapState('search', [ 'historicalDate', 'criteria', 'expertMode', ]),
    ...mapGetters('search', [ 'criteriaCount', ]),
  },
  methods: {
    resetCriterias () {
      EventBus.$emit('clear-list')
      this.resetCriteria()
      this.routerSearch()
    },

    ...mapActions('search', [ 'searchWithParams', ]),
    ...mapMutations('search', {
      addCriteria: ADD_CRITERIA,
      resetCriteria: RESET_CRITERIA,
      setDate: SET_HISTORICAL_DATE,
      clearDates: REMOVE_HISTORICAL_DATE,
    }),
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"

  $input-height = $input-lg
  $input-height-mobile = $input-md

  .expert-form
    display flex
    flex-direction column

    .historical-date
      display none

    .options-block
      padding 35px 0 40px
      border-bottom 5px solid $default-color-light-1
      display flex
      align-items center
      justify-content space-between

      .meet
        color $default-color-bold
        font-size 85%
        font-weight 600
        display flex
        align-items center

        .inline
          display inline-block

        .meet-select
          margin 0 15px
          width 120px

      .config
        .config-btn
          margin-right 5px
          margin-left 5px

          &:first-child
            margin-left 0

          &:last-child
            margin-right 0

    .criteria-block
      padding-top 30px

    .actions-block
      padding 10px 0 25px
      justify-content flex-end
      display flex

      .notification-text
        font-size 95%
        align-items center
        display flex
        padding 10px 15px 10px 0

      .add-btn, .search-btn
        min-width 250px

      .add-btn-tip-box
        margin-right 20px

  @media screen and (max-width: $laptop)
    .expert-form
      .historical-date
        display flex
        padding 15px 0 25px

      .actions-block
        width calc(100% - 30px)
        justify-content space-between

        .add-btn, .search-btn
          flex 1

        .add-btn-tip-box
          margin-right 0

  @media screen and (max-width: $tablet)
    .expert-form
      margin 0 -20px

      .options-block
        margin-top 10px
        padding 25px 20px
        border-bottom none
        border-top 1px solid $default-color-light-1
        display flex
        display none //while empty
        align-items center
        justify-content space-between

        .meet
          font-size 0.75rem

          .meet-select
            margin 0 10px
            width 120px

        .config
          .config-btn
            display none

      .criteria-block
        padding-top 0

      .historical-date
        padding 20px

        .default
          .datepicker-label
            font-size 0.75rem

          .datepicker-input
            width 140px
            font-size 0.75rem

      .actions-block
        padding 0 20px
        width 100%
        flex-direction column

        .add-btn
          margin 15px 0

</style>



// WEBPACK FOOTER //
// src/components/search-components/ExpertForm.vue